import React from 'react';
import './Button.css';

interface ButtonProps {
  variant?: 'primary' | 'ghost';
  href?: string;
  onClick?: () => void;
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({ variant = 'primary', href, onClick, children }) => {
  const cls = `btn btn-${variant}`;
  if (href) return <a href={href} className={cls}>{children}</a>;
  return <button className={cls} onClick={onClick}>{children}</button>;
};

export default Button;